module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nomeFantasia"
    }
  }, [_c('h3', [_vm._v("Assinatura")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.tipo),
      callback: function($$v) {
        _vm.$set(_vm.form, "tipo", $$v)
      },
      expression: "form.tipo"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Em conjunto"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Isolada"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.form.tipo === 'Em conjunto') ? _c('em', [_c('strong', [_vm._v("Importante:")]), _vm._v(" A assinatura perante Instituições Públicas e Bancárias só terá validade se tiver a assinatura de ambos os sócios")]) : _vm._e()], 1), _vm._v(" "), _c('h3', [_vm._v("Será exercida pelos sócios:")]), _vm._v(" "), _vm._l((_vm.form.socios), function(socio, index) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Nome Completo",
        "prop": 'socios.' + index + '.nome',
        "rules": {
          required: true,
          message: 'O nome é obrigatório',
          trigger: 'blur'
        }
      }
    }, [(_vm.form.socios.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.removerSocio(socio)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e(), _vm._v(" "), _c('el-input', {
      model: {
        value: (socio.nome),
        callback: function($$v) {
          _vm.$set(socio, "nome", $$v)
        },
        expression: "socio.nome"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.adicionarSocio
    }
  }, [_vm._v("Adicionar Sócio")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-479f25a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConstituicaoDeEmpresa/AdministracaoAssinatura.vue
// module id = 201
// module chunks = 1